(function () {
  function addEventDelegateSafe(selector, handler) {
    document.addEventListener('click', function (event) {
      var target = event.target.closest(selector);
      if (target) handler(event, target);
    });
  }

  addEventDelegateSafe('[data-quick-add-variant]', function (event, button) {
    event.preventDefault();
    if (button.classList.contains('is-loading')) return;

    var variantId = button.getAttribute('data-quick-add-variant');
    if (!variantId || !window.Shopify || !window.Shopify.routes) return;

    button.classList.add('is-loading');
    button.disabled = true;

    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );
    if (sectionsToBundle.indexOf('cart-count') === -1) sectionsToBundle.push('cart-count');

    var addUrl =
      (window.MinimogSettings && window.MinimogSettings.routes && window.MinimogSettings.routes.cart_add_url) ||
      window.Shopify.routes.root + 'cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: sectionsToBundle,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status || response.errors) {
          console.error('Quick add error:', response.description || response.errors);
          button.classList.remove('is-loading');
          button.disabled = false;
          return;
        }

        if (window.MinimogEvents && window.MinimogTheme) {
          window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: response });
        }

        var drawer = document.querySelector('m-cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();

        button.classList.remove('is-loading');
        button.classList.add('is-added');
        setTimeout(function () {
          button.classList.remove('is-added');
          button.disabled = false;
        }, 1200);
      })
      .catch(function (error) {
        console.error('Quick add error:', error);
        button.classList.remove('is-loading');
        button.disabled = false;
      });
  });
})();
